import {
  GET_CART_REQUEST,
  GET_CART_HOSTED_PAYMENT_REQUEST,
  ADD_CART_ITEM_REQUEST,
  ADD_CART_QUICK_ITEM_REQUEST,
  REMOVE_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_REQUEST,
  UPDATE_AND_CHARGE_CART_REQUEST,
  UPDATE_AND_CHARGE_CART_PAYGATE_REQUEST,
  UPDATE_CART_AND_SAVE_SHIPPING_ADDRESS_REQUEST,
  CHARGE_CART_REQUEST,
  SIDE_CART_VISIBLE,
  SIDE_CART_NOT_VISIBLE,
  ADD_COUPON_OR_GIFTCARD_REQUEST,
  CHECKOUT_STEP_REQUEST,
  SEND_CART_TO_HOSTED_PAYMENT_REQUEST
} from './constants';

export const getCartForHostedPayment = (successFunction, errorFunction) => ({
  type: GET_CART_HOSTED_PAYMENT_REQUEST,
  successFunction,
  errorFunction
});

export const getCart = () => ({ type: GET_CART_REQUEST });

export const addCartItem = (item, analytics, successFunction) => ({
  type: ADD_CART_ITEM_REQUEST,
  item,
  analytics,
  successFunction
});

export const addCartQuickItem = (item, analytics, errorFunction) => ({
  type: ADD_CART_QUICK_ITEM_REQUEST,
  item,
  analytics,
  errorFunction
});

export const removeCartItem = (sku, useLoyaltyPoints) => ({
  type: REMOVE_CART_ITEM_REQUEST,
  sku,
  useLoyaltyPoints
});

export const updateCartItem = (
  sku,
  quantity,
  useLoyaltyPoints,
  errorFunction
) => ({
  type: UPDATE_CART_ITEM_REQUEST,
  quantity,
  sku,
  useLoyaltyPoints,
  errorFunction
});

export const showSideCart = () => ({
  type: SIDE_CART_VISIBLE
});

export const hideSideCart = () => ({
  type: SIDE_CART_NOT_VISIBLE
});

export const checkoutStep = (step, cart) => ({
  type: CHECKOUT_STEP_REQUEST,
  payload: {
    step,
    cart
  }
});

export const updateCart = (cart, successFunction, errorFunction) => ({
  type: UPDATE_CART_REQUEST,
  cart,
  successFunction,
  errorFunction
});

export const updateAndSaveShippingAddress = (
  cart,
  address,
  successFunction
) => ({
  type: UPDATE_CART_AND_SAVE_SHIPPING_ADDRESS_REQUEST,
  cart,
  address,
  successFunction
});

export const sendToHostedPayment = (redirectFunction) => ({
  type: SEND_CART_TO_HOSTED_PAYMENT_REQUEST,
  redirectFunction
});

export const updateAndChargePayGate = (
  address,
  creditCard,
  isSaveAddress,
  successFunction,
  redirectFunction,
  errorFunction
) => ({
  type: UPDATE_AND_CHARGE_CART_PAYGATE_REQUEST,
  address,
  creditCard,
  isSaveAddress,
  redirectFunction,
  successFunction,
  errorFunction
});

export const updateAndChargeCart = (
  address,
  tender,
  token,
  newCreditCardToken,
  isSaveAddress,
  isSaveCreditCard,
  successFunction,
  errorFunction
) => ({
  type: UPDATE_AND_CHARGE_CART_REQUEST,
  address,
  tender,
  token,
  newCreditCardToken,
  isSaveAddress,
  isSaveCreditCard,
  successFunction,
  errorFunction
});

export const chargeCart = (recaptchaToken, successFunction, errorFunction) => ({
  type: CHARGE_CART_REQUEST,
  recaptchaToken,
  successFunction,
  errorFunction
});

export const addCouponOrGiftCard = (
  promocode,
  succcessFunction,
  errorFunction
) => ({
  type: ADD_COUPON_OR_GIFTCARD_REQUEST,
  promocode,
  succcessFunction,
  errorFunction
});
